import $api from "@/frontend/shared/api/axios";
import { TStagesResponse } from "../../const/const";
import { createCommonFilter } from "../../lib/createCommonFilter";
import { ConditionRowFilterExtended } from "@/frontend/components/FilterV2/model/types";

export async function postGetCompaniesData(
  {
    filters,
    pipelineId,
    noCompanies
  }: {
    filters: ConditionRowFilterExtended[];
    pipelineId: number;
    noCompanies?: boolean;
  },
  options: any = {}
): Promise<TStagesResponse> {
  const requestBody = {
    filters,
    pipelineId: pipelineId.toString(),
    addCompanies: noCompanies ? "false" : "true"
  };

  const res = await $api.post("/stages/v2", requestBody, options);
  return res.data.data;
}
